import { actionGenerator } from '../../utils/redux/actionGenerator';
import { INearbyHousesInfoState } from '../../types/redux/nearbyHousesInfo';

export enum ENearbyHousesActionTypes {
  Request = 'nearbyHousesInfo/request',
  Success = 'nearbyHousesInfo/success',
  Failure = 'nearbyHousesInfo/failure',
}

export const successAction = actionGenerator<typeof ENearbyHousesActionTypes.Success, INearbyHousesInfoState>(
  ENearbyHousesActionTypes.Success,
);

export const requestAction = actionGenerator<typeof ENearbyHousesActionTypes.Request>(ENearbyHousesActionTypes.Request);
export const failureAction = actionGenerator<typeof ENearbyHousesActionTypes.Failure>(ENearbyHousesActionTypes.Failure);

export const getSuccessAction = (data: INearbyHousesInfoState) => successAction(data);

export type TNearbyHousesInfoActions =
  | ReturnType<typeof successAction>
  | ReturnType<typeof requestAction>
  | ReturnType<typeof failureAction>;
